/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
`

export default function HelpIco() {
  return (
    <Fragment>
      <svg xmlns="http://www.w3.org/2000/svg" width="39.514" height="39.512" viewBox="0 0 39.514 39.512" css={Color}>
        <g transform="translate(-340.105 -114.195)">
          <path d="M342.751,143.823a19.752,19.752,0,1,1,17.131,9.884A19.755,19.755,0,0,1,342.751,143.823Zm9.209-23.577a15.8,15.8,0,1,0,7.891-2.12A15.8,15.8,0,0,0,351.96,120.246Z" fill="#ddd" />
          <path d="M360.271,138.752a1.5,1.5,0,0,1-1.5-1.42s-.013-.236,0-2.44a1.5,1.5,0,0,1,1.177-1.458c.956-.21,3.2-1.483,3.2-2.993a2.909,2.909,0,0,0-.839-2.108,2.864,2.864,0,0,0-2.037-.85c-1.7,0-2.73,1.131-2.73,1.629a1.5,1.5,0,0,1-3,0c0-2.19,2.355-4.629,5.734-4.629a5.883,5.883,0,0,1,5.872,5.9c0,2.9-2.5,4.774-4.376,5.586,0,.966,0,1.2,0,1.24a1.5,1.5,0,0,1-1.437,1.542Z" fill="#ddd" />
          <circle cx="1.646" cy="1.646" r="1.646" transform="translate(358.66 140.656)" fill="#ddd" />
        </g>
      </svg>
    </Fragment>
  )
}
